"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.all = exports.Destination = void 0;
/**
 * holds destination data
 * @param name - destination's name
 * @param pattern - destination's pattern prefix (later being recognized by a subscription filter)
 * @param data - destination's metadata
 * @param stages - destination's stages data
 * @constructor
 */
class Destination {
    constructor(name, pattern, data, stages) {
        this.name = name;
        this.pattern = pattern;
        this.data = data;
        this.stages = stages;
    }
    /**
     * whether to update this destination. update when:
     * 1. metadataDestination is undefined (=not supplied - treat as ALL for backwards compatibility)
     * 2. metadataDestination is set to ALL explicitly
     * 3. metadataDestination is of the same as this destination
     * @param metadataDestination
     * @returns {boolean}
     */
    shouldUpdate(metadataDestination) {
        return !metadataDestination || metadataDestination === "ALL" /* DESTINATION.ALL */ || metadataDestination === this.name;
    }
}
exports.Destination = Destination;
const DESTINATIONS = Object.freeze({
    ["SPLUNK" /* DESTINATION.SPLUNK */]: {
        name: "SPLUNK",
        pattern: "EVENT"
    },
    ["DATA_LAKE" /* DESTINATION.DATA_LAKE */]: {
        name: "DATA_LAKE",
        pattern: "LAKE"
    },
    ["ALL" /* DESTINATION.ALL */]: {
        name: "ALL"
    }
});
/**
 * returns an array of all new initiated Destination instances
 * @returns {Destination[]}
 */
const all = () => {
    return Object.entries(DESTINATIONS)
        .filter(([destination]) => destination !== "ALL" /* DESTINATION.ALL */)
        .map(([, destinationData]) => new Destination(destinationData.name, destinationData.pattern, {}, {}));
};
exports.all = all;
//# sourceMappingURL=destination.js.map